import React, {Component} from 'react'
import {
    Card,
    Table,
    Button,
    message, Descriptions,
    Tag, Divider,
    Drawer,Tooltip,List,
    Row, Col, Form, Badge, Select, Modal, Input, Collapse, PageHeader, InputNumber, Empty, Spin, Space, Alert
} from 'antd';
import {
    getPerformanceEvaList,
    savePerformanceEva,
    appointSuperLeader,
    getUserListForDropbox,
    clearLeaderPerformanceRate, del360ClassUser
} from '../../request'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as Icon from '@ant-design/icons';
import IconFolder from '../../public/iconfont/iconFolder'
import {withRouter} from "react-router-dom";
const { Panel } = Collapse;

import './performance.less'
class PerformanceDetail extends Component {
    performanceRef = React.createRef()
    surveyModal = React.createRef()
    formRef = React.createRef()
    state = {
        dataSource:[],
        dicList:{},
        SurveyQaList:[],
        columns:[],
        loading:false,
        visible:false,
        systemItem:{},
        formParam:{
            userId:this.props.id!=0?this.props.id:null,
        },
        total:0,
        formDataParam:{
            name:''
        },
        detailDrawerVisible:false,
        submitParam:{},
        userName:'',
        userList:[],
        superLeaderId:undefined
    };
    initTableDataList(){
        this.setState({ loading: true });
        console.log(this.state.formParam)
        getPerformanceEvaList(this.state.formParam).then(res=>{
            this.setState({
                loading: false,
                dataSource:res.list,
                userName:res.currentUserName||''
            })
        })
    }
    initUserList = ()=>{
        getUserListForDropbox({type:0}).
        then(res=>{
            this.setState({
                userList:[...res]
            })
        })
    }
    handlePushFilterValueChange = (changedValues, allValues, index)=>{

        // let param = this.state.dataSource
        // param[index].content = allValues.content
        console.log('change',changedValues, allValues)
        this.setState({
            submitParam:allValues
        })
        // this.saveValues(0)
    }
    handleBlur = (val,index)=>{
        console.log(val,this.state.submitParam)
        this.saveValues(0,index)
    }
    saveValues = (state,index)=>{
        let param = this.state.dataSource[index]
        let setParam = {...param,...this.state.submitParam}
        savePerformanceEva({...setParam,publish:state}).then(res=>{
            message.success(state==1?'保存成功':'已存草稿')
            if(state==1){
                this.setState({
                    submitParam:{}
                })
                this.initTableDataList()

            }

        })
    }
    downloadValues = (item)=>{
        this.downloadPDF('performance'+item.periodId,item.periodHeadString)
    }
    downloadPDF = (id,name) => {
        const input = document.getElementById(id); // 假设你要转换的元素有id="content"
        html2canvas(input, { scale: 2 }).then(canvas => {
            const contentHeight = canvas.height;
            const pageNum = Math.floor(contentHeight / 2 / 1092);
            // 使用toDataURL转化为Base64编码
            const pageData = canvas.toDataURL('image/jpeg', 1.0);
            // 参数：纵向横向选择：'p'纵向，'l'横向，
            // 第二个单位，第三个尺寸格式，如[200,300]，可以也直接写'a4'等标准纸张大小
            const doc = new jsPDF('p', 'pt', 'a4');
            // 参数：图片内容，左偏移，上偏移，宽度，高度，a4大小的宽高为595.28，841.89
            doc.addImage(pageData, 5, 5, 580, 830 * pageNum, 'img');
            if (pageNum > 1) {
                for (let i = 1; i < pageNum; i += 1) {
                    doc.addPage();
                    doc.addImage(pageData, 5, -i * 841, 580, 830 * pageNum, 'img');
                }
            }
            doc.save(name+'.pdf'); // 参数：导出文件的命名
        });
    };
    clearLeaderScore = (item)=>{
        Modal.confirm({
            title:'提示',
            content:'确定要清空leader评分吗？清空leader评分同时也会清除「部门leader评分」，请谨慎选择！',
            onOk:()=>{
                clearLeaderPerformanceRate({ userId:item.userId,periodId:item.periodId}).then(res=>{
                    message.success('清除成功')
                    this.setState({
                        submitParam:{}
                    })
                    this.initTableDataList()
                })
            },
            onCancel:()=>{

            }

        })

    }
    initTableColumns = (listRecord,listIndex)=>{
        let publicCol = {
            selfRate:<span>员工自评<br/>({listRecord.selfRatePercent})</span>,
            leaderRate:<span>直属leader<br/>({listRecord.leaderRatePercent})</span>,
            superLeaderRate:<span>部门leader<br/>{listRecord.superLeaderName||''}<br/>({listRecord.superLeaderRatePercent?listRecord.superLeaderRatePercent:'0%'})</span>
        }
        let col1 = {
            project:'考核项目1',
            content:'考核内容',
            result:<span>实际达成情况<br/>（避免概述，须有案例或数据支撑）</span>,
            standard:'评价标准'
        }
        let col2 = {
            project:'考核项目2',
            type:'考核维度',
            selfContent:'参考评价标准要求员工填写相应内容',
            standard:'评价标准'
        }
        let col3 = {
            project:'考核项目3',
            person:'评估人',
            suggest:'定性建议',
            score:'定量得分'
        }
        let col1Set = {...col1,...publicCol}
        let column1 = Object.keys(col1Set).map(item=> {
            let initObj = {
                title: col1Set[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='project'){
                return {
                    ...initObj,
                    width:'100px'
                }
            }else if(item=='content'){
                return {
                    ...initObj,
                    width:'220px'
                }
            }else if(item=='standard'){
                return {
                    ...initObj,
                    align:'left',
                    render:(text, record, index)=>{
                        let list = text.split('\n')
                        let scoreLevel = {
                            0:'red',
                            1:'pink',
                            2:'gold',
                            3:'blue',
                            4:'green',

                        }
                        return (
                            <>
                                {
                                    list.map((item1,index1)=>{
                                        return <>
                                            <Badge status={scoreLevel[index1]} text={
                                                <span style={{fontSize:'12px'}}>{item1}</span>
                                            } />
                                            <Divider style={{margin:'3px 0'}} dashed />
                                        </>
                                    })
                                }
                            </>
                        )
                    }
                }
            }else if(item=='selfRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item hidden name={'periodId'}></Form.Item>
                                <Form.Item hidden name={'userId'}></Form.Item>
                                <Form.Item name={'kpiSelfRate'}>
                                    <InputNumber onBlur={(val)=>this.handleBlur(val,listIndex)} disabled={!listRecord.selfEdit} style={{width:'100%'}} min={0} max={listRecord.kpiFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='leaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={'kpiLeaderRate'}>
                                    <InputNumber onBlur={(val)=>this.handleBlur(val,listIndex)} disabled={!listRecord.leaderEdit} style={{width:'100%'}} min={0} max={listRecord.kpiFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='superLeaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={'kpiSuperLeaderRate'}>
                                    <InputNumber onBlur={(val)=>this.handleBlur(val,listIndex)} disabled={listRecord.superLeaderShow==1&&listRecord.superLeaderEdit?false:true} style={{width:'100%'}} min={0} max={listRecord.kpiFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='result'){
                return {
                    ...initObj,
                    width:'280px',
                    render:(text, record, index)=>{
                        return (
                            <Form.Item name={'kpiSelfContent'}>
                                <Input.TextArea onBlur={(val)=>this.handleBlur(val,listIndex)} autoSize disabled={!listRecord.selfEdit} />
                            </Form.Item>
                        )
                    }
                }
            }else{
                return initObj
            }

        })
        let col2Set = {...col2,...publicCol}
        let column2 = Object.keys(col2Set).map(item=> {
            let initObj = {
                title: col2Set[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='project'){
                return {
                    ...initObj,
                    width:'100px',
                    onCell:(_,index)=>{
                        if(index===0){
                            return {rowSpan:7}
                        }else{
                            return {rowSpan:0}
                        }},
                    render:()=>{
                        return listRecord.valuesTypeString
                    }
                }
            }else if(item=='type'){
                return {
                    ...initObj,
                    width:'220px',
                    render:(text,record,index)=>{
                        return record.record.type
                    }
                }
            }else if(item=='selfContent'){
                return {
                    ...initObj,
                    width:'280px',
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item hidden name={[record.name,'id']}>
                                </Form.Item>
                                <Form.Item name={[record.name,'selfContent']}>
                                    <Input.TextArea onBlur={(val)=>this.handleBlur(val,listIndex)} autoSize disabled={!listRecord.selfEdit} />
                                </Form.Item>
                            </>

                        )
                    }
                }
            }else if(item=='standard'){
                return {
                    ...initObj,
                    align:'left',
                    render:(text, record, index)=>{
                        let info = record.record.standard
                        let list = info?info.split('\n'):[]
                        let scoreLevel = {
                            0:'red',
                            1:'pink',
                            2:'gold',
                            3:'blue',
                            4:'green',
                        }
                        return (
                            <div>
                                {
                                    list.map((item1,index1)=>{
                                        return <>
                                            <Badge status={scoreLevel[index1]} text={
                                                <span style={{fontSize:'12px'}}>{item1}</span>
                                            } />
                                            <Divider style={{margin:'3px 0'}} dashed />
                                            </>
                                    })
                                }
                            </div>
                        )
                    }
                }
            }else if(item=='selfRate'){
                return {
                    ...initObj,
                    width: 80,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={[record.name,'selfRate']}>

                                <InputNumber onBlur={(val)=>this.handleBlur(val,listIndex)} disabled={!listRecord.selfEdit} style={{width: '100%'}} step={0.5} min={0}
                                             max={record.record.valuesFullScore} defaultValue={0}/>
                                </Form.Item>
                             </>
                        )
                    }
                }
            }else if(item=='leaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={[record.name,'leaderRate']}>

                                <InputNumber onBlur={(val)=>this.handleBlur(val,listIndex)} disabled={!listRecord.leaderEdit} style={{width:'100%'}} step={0.5} min={0} max={record.record.valuesFullScore} defaultValue={0} />

                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='superLeaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={[record.name,'superLeaderRate']}>
                                    <InputNumber onBlur={(val)=>this.handleBlur(val,listIndex)} disabled={listRecord.superLeaderShow==1&&listRecord.superLeaderEdit?false:true} style={{width:'100%'}} step={0.5} min={0} max={record.record.valuesFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else{
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        {record[item]}
                    }
                }
            }

        })
        let cellM = (_,index)=>{
            if (index === 1) {
                return { colSpan: 0 };
            }
        }
        let column3 = Object.keys(col3).map(item=> {
            let initObj = {
                title: col3[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='project'){
                return {
                    ...initObj,
                    width:100
                }
            }else if(item=='person'){
                return {
                    ...initObj,

                    children:[
                        {title:'上级',dataIndex:'leader',width:120,onCell: (_, index) => {
                                if(index==1){
                                    return { colSpan: 4 }
                                }
                            },
                        },
                        {title:'协作伙伴',dataIndex:'peer',width:120,onCell:cellM},
                        {title:'下级伙伴',dataIndex:'down',width: 140,onCell:cellM},
                    ]
                }
            }else if(item=='suggest'){
                return {
                    ...initObj,
                    align: 'left',
                    onCell:cellM,
                    render:(text,record)=>{
                        let arr = text||[]
                        return (
                            <>
                                <List
                                    className={'eval-360-list'}
                                    dataSource={arr}
                                    renderItem={(item1)=>(
                                        <List.Item key={item1.title}>
                                            <List.Item.Meta
                                                title={item1.title}
                                                description={
                                                    <div>
                                                        {item1.answer.map(item2=>{
                                                            return <>
                                                                <Badge status="processing" />{item2}<br/>
                                                                </>
                                                        })}
                                                    </div>
                                                }
                                            />
                                        </List.Item>
                                    )}
                                />

                            </>
                        )
                    }
                }
            }else if(item=='score'){
                return {
                    ...initObj,width: 240
                }
            }else{
                return initObj
            }

        })
        return {
            column1,column2,column3
        }
    }
    initTableDataSource = (record)=>{
        let dataSource1 = [
            {
                project:record.kpiTypeString,
                content:<p style={{whiteSpace:'pre-line'}}>{record.kpiContentString}</p>,
                standard:record.kpiEvaluateStandardString,
                result:record.kpiSelfContent,
                selfRate:record.kpiSelfRate,
                leaderRate:record.kpiLeaderRate,
                superLeaderRate:record.kpiSuperLeaderRate,
            }
        ]
        let dataSource2 = [
            ...record.valuesData
        ]
        let data360 = record.evalResultVo||{}
        let refUsers = data360.refUsers||{}
        let dataSource3 = [
            {
                project:<p style={{whiteSpace:'pre-line'}}>{data360.name}</p>,
                peer:refUsers['协作者']?refUsers['协作者'].join(','):'-',
                down:refUsers['下级']?refUsers['下级'].join(','):'-',
                leader:refUsers['领导']?refUsers['领导'].join(','):'-',
                suggest:data360.suggest,
                score:data360.score,
            },
        ]
        let dataSource4 = [
            {
                title: '【评分合计】考核项目1+2（公式：KPI+价值观七项平均分x5）',
                selfRateSum: record.selfRateSum,
                leaderRateSum: record.leaderRateSum,
                superLeaderRateSum: record.superLeaderRateSum,
            }
        ]
        let dataSource5 = [
            {
                title:'总分',
                subs:record.total3TypeString,
                score:record.totalRateSum
            },
        ]
        let dataSource6 = [
            {
                title:record.coolTitle||'完成情况',
                result:record.coolScoreResult,
                coolComplete:record.coolComplete
            },
        ]
        let dataSource7 = [
            {
                title:'最终总分',
                subs:record.total4TypeString,
                score:record.total4RateSum
            },
        ]
        return {
            dataSource1,dataSource2,dataSource3,dataSource4,dataSource5,dataSource6,dataSource7
        }
    }
    getPerformanceState = (item)=>{
        return (
            <span style={{marginLeft:'10px'}}>
            {item.scoreGrade == 1 ?
                <Tag color={'red'}>不合格</Tag> :
                (item.scoreGrade == 2 ? <Tag color={'blue'}>合格</Tag> :
                    (item.scoreGrade == 3 ? <Tag color={'green'}>优秀</Tag> : ''))}
            </span>
            
        )
    }

    addSuperLeader = (item)=>{
        appointSuperLeader({
            userId:this.state.formParam.userId,
            periodId:item.periodId,
            superLeaderId:this.state.superLeaderId
        }).then(res=>{
            message.success('添加成功')
            this.initTableDataList()
        })
    }
    componentDidMount(){
        this.initUserList()
        this.initTableDataList()

    }
    render() {
        const locationQuery = new URLSearchParams(window.location.search)
        const periodId = locationQuery.get('periodId')
        const {dataSource, columns, loading, detailDrawerVisible, dicList, editParam} = this.state;
        return (
            <>
                <Card title={
                    this.props.id?
                        <>
                            <span style={{marginRight:'10px',fontWeight:'bolder',cursor:'pointer'}} onClick={()=>this.props.history.go(-1)}><Icon.ArrowLeftOutlined/></span>
                            {
                                '绩效评估：' + this.state.userName
                            }
                        </>:
                        '绩效评估：我的'
                } bordered={false}
                      className={'card-fixed-head-wrap performance-detail-wrap'}>
                    <Spin spinning={loading}>
                        {
                            this.state.dataSource.length > 0 ?
                                <Collapse defaultActiveKey={[periodId]}>
                                    {
                                        this.state.dataSource.map((item, index) => {
                                            let columnsAll = this.initTableColumns(item,index)
                                            let dataSourceAll = this.initTableDataSource(item)
                                            return (
                                                <Panel forceRender collapsible={item.viewable ? 'header' : 'disabled'}
                                                       header={
                                                           <>
                                                               {item.periodString}
                                                               {
                                                                   this.getPerformanceState(item)
                                                               }
                                                           </>
                                                       } key={item.periodId}>
                                                    <div style={{
                                                        marginBottom: '10px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <div>
                                                            {
                                                                item.showSuperLeaderSelect ?
                                                                    <>

                                                                        <Select
                                                                            style={{minWidth: '200px'}}
                                                                            showSearch
                                                                            optionFilterProp="children"
                                                                            fieldNames={{
                                                                                label: 'USER_NICK',
                                                                                value: 'USER_ID'
                                                                            }}
                                                                            filterOption={(input, option) => {
                                                                                let searchText = (option?.USER_NICK ?? '') + (option?.pinyin ?? '')
                                                                                return searchText.toLowerCase().includes(input.toLowerCase())
                                                                            }
                                                                            }
                                                                            allowClear
                                                                            placeholder="请添加部门leader"
                                                                            options={this.state.userList}
                                                                            onChange={(value, option) => {
                                                                                this.setState({
                                                                                    superLeaderId: value
                                                                                })

                                                                            }}
                                                                        />
                                                                        <Button
                                                                            onClick={() => this.addSuperLeader(item)}
                                                                            danger type={'primary'}>添加</Button>
                                                                        <span style={{marginLeft:'10px'}}>
                                                                            <Tooltip title={'请为该员工指定对应的部门leader（注意：指定的部门leader需要对员工的KPI内容有所了解），如果没有可不进行指定'}>
                                                                                <span style={{color:'green'}}><Icon.InfoCircleOutlined/> 说明</span>
                                                                            </Tooltip>
                                                                        </span>

                                                                    </> : ''
                                                            }

                                                        </div>
                                                        <div>
                                                            <Space>
                                                                {item.showSave ?
                                                                    <Button size={'small'} danger ghost
                                                                            onClick={() => this.saveValues(1,index)}
                                                                            color={'cyan'}>保存</Button>
                                                                    : ''}
                                                                {item.leaderEdit ?
                                                                    <Button size={'small'} danger
                                                                            onClick={() => this.clearLeaderScore(item)}
                                                                            color={'pink'}>清空评分</Button>
                                                                    : ''}
                                                                <Button size={'small'}
                                                                        type={'primary'} ghost
                                                                        onClick={() => this.downloadValues(item)}
                                                                        color={'green'}>导出</Button>
                                                            </Space>


                                                        </div>
                                                    </div>
                                                    <Form id={'performance' + item.periodId}
                                                          ref={this.formRef}
                                                          className={'performance-form'} initialValues={item}
                                                          onFieldsChange={(changedFields, allFields) => console.log('filedChnage', changedFields, allFields)}
                                                          onValuesChange={(changedValues, allValues) => this.handlePushFilterValueChange(changedValues, allValues, index)}
                                                    >
                                                        <Table
                                                            size={'small'}
                                                            bordered
                                                            pagination={false}
                                                            columns={
                                                                columnsAll.column1
                                                            }
                                                            dataSource={dataSourceAll.dataSource1}

                                                        />
                                                        <Form.List name={'valuesData'} initialValue={item.valuesData}>
                                                            {(fields, operation) => {
                                                                let newFields = fields.map((field, index) => {
                                                                    field.record = item.valuesData[index]
                                                                    return field
                                                                })
                                                                return <Table
                                                                    size={'small'}
                                                                    bordered
                                                                    pagination={false}
                                                                    columns={
                                                                        columnsAll.column2
                                                                    }
                                                                    dataSource={newFields}
                                                                />
                                                            }}
                                                        </Form.List>

                                                        <Table
                                                            className={'table-score'}
                                                            showHeader={false}
                                                            size={'small'}
                                                            bordered
                                                            pagination={false}
                                                            columns={
                                                                [
                                                                    {dataIndex: 'title', title: '总分', align: 'center'},
                                                                    {
                                                                        dataIndex: 'selfRateSum',
                                                                        title: '得分',
                                                                        width: 80,
                                                                        align: 'center'
                                                                    },
                                                                    {
                                                                        dataIndex: 'leaderRateSum',
                                                                        title: '得分',
                                                                        width: 80,
                                                                        align: 'center'
                                                                    },
                                                                    {
                                                                        dataIndex: 'superLeaderRateSum',
                                                                        title: '得分',
                                                                        width: 80,
                                                                        align: 'center'
                                                                    },
                                                                ]
                                                            }
                                                            dataSource={
                                                                dataSourceAll.dataSource4
                                                            }
                                                        />
                                                        <Table
                                                            size={'small'}
                                                            bordered
                                                            pagination={false}
                                                            columns={
                                                                columnsAll.column3
                                                            }
                                                            dataSource={dataSourceAll.dataSource3}
                                                        />
                                                        <Table
                                                            className={'table-score'}
                                                            showHeader={false}
                                                            size={'small'}
                                                            bordered
                                                            pagination={false}
                                                            columns={
                                                                [
                                                                    {
                                                                        dataIndex: 'title',
                                                                        title: '总分',
                                                                        width: 100,
                                                                        align: 'center'
                                                                    },
                                                                    {dataIndex: 'subs', title: '描述'},
                                                                    {
                                                                        dataIndex: 'score',
                                                                        title: '得分',
                                                                        width: 240,
                                                                        align: 'center'
                                                                    },
                                                                ]
                                                            }
                                                            dataSource={
                                                                dataSourceAll.dataSource5
                                                            }
                                                        />
                                                        <Table
                                                            size={'small'}
                                                            bordered
                                                            pagination={false}
                                                            columns={
                                                                [
                                                                    {
                                                                        dataIndex: 'title',
                                                                        title: '培训模块',
                                                                        width: 100,
                                                                        align: 'center'
                                                                    },
                                                                    {
                                                                        dataIndex: 'result',
                                                                        title: '当月培训旅程',
                                                                        render: (text, record, index) => {
                                                                            return (
                                                                                <>
                                                                                    {
                                                                                        (text || []).map(item2 => {
                                                                                            return <div><Badge
                                                                                                status={'processing'}
                                                                                                text={item2}/></div>
                                                                                        })
                                                                                    }
                                                                                </>
                                                                            )
                                                                        }
                                                                    },
                                                                    {
                                                                        dataIndex: 'coolComplete',
                                                                        title: '培训得分',
                                                                        width: 240,
                                                                        align: 'center'
                                                                    },
                                                                ]
                                                            }
                                                            dataSource={dataSourceAll.dataSource6}
                                                        />
                                                        <Table
                                                            className={'table-score'}
                                                            showHeader={false}
                                                            size={'small'}
                                                            bordered
                                                            pagination={false}
                                                            columns={
                                                                [
                                                                    {
                                                                        dataIndex: 'title',
                                                                        title: '总分',
                                                                        width: 100,
                                                                        align: 'center'
                                                                    },
                                                                    {dataIndex: 'subs', title: '描述'},
                                                                    {
                                                                        dataIndex: 'score',
                                                                        title: '得分',
                                                                        width: 240,
                                                                        align: 'center',
                                                                        render: (text, record, index) => {
                                                                            return (
                                                                                <>
                                                                                    {text}
                                                                                    {this.getPerformanceState(item)}
                                                                                </>

                                                                            )
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                            dataSource={
                                                                dataSourceAll.dataSource7
                                                            }
                                                        />
                                                    </Form>
                                                </Panel>
                                            )
                                        })
                                    }
                                </Collapse>
                                :
                                <Empty/>
                        }

                    </Spin>
                </Card>
            </>

        )
    }
}
export default withRouter(PerformanceDetail)